import { createFileRoute } from "@tanstack/react-router";
import { DistributionWires } from "@/components/DistributionWires";

function RouteComponent() {
  return <DistributionWires />;
}

export const Route = createFileRoute("/_authenticated/distributions/wires/")({
  component: RouteComponent,
  staticData: { page: "distributions" },
});
